#import "../../common/graphql/SecureRowLevelsEntityFields.graphql"
query PayCycleCommonTypes {
  invoiceStatusTypes {
    nodes {
      id
      statusType
    }
  }
  paymentTransactionTypes {
    nodes {
      id
      description
      transactionType
    }
  }
  paymentAccounts(orderBy: [NAME_ASC, BANK_ACCOUNT_NUMBER_ASC],filter:{_isTrackingAccount:{equalTo:true}}) {
    nodes {
      id
      name
      bankAccountNumber
      currency {
        id
        isoCode
        name
      }
    }
  }
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
  companyCorporatePeriods(orderBy: [IS_ENTRY_ALLOWED_DESC, START_DATE_ASC]) {
    nodes {
      isEntryAllowed
      id
      _periodYear
      startDate
      endDate
    }
  }
}
